/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const RECAPTCHA_ENTERPRISE = 'ENTERPRISE';
export const RECAPTCHA_V3 = 'V3';
export const RECAPTCHA_V2 = 'V2';

export const MOBILE_TYPES = ['ENTERPRISE_IOS', 'ENTERPRISE_ANDROID'];

export const RECAPTCHA_CHALLENGE_FAILED = 'challenge failed';
export const RECAPTCHA_CHALLENGE_REQUIRED = 'additional challenge required';
export const RECAPTCHA_ERROR =
    'Our system has detected abnormal activity from your computer network. Please try again.';

export const RECAPTCHA_BAD_FINGERPRINT = 'bad fingerprint';
export const RECAPTCHA_ERROR2 =
    'Our system has detected abnormal activity from your computer network. Please try refreshing the page or re-logging into your account.';
